module.exports = __webpack_public_path__ + "img/af.83d7008a.png";